export const LOGIN = () => `/login`;
export const PROFILE = () => `/profile`;
export const REGISTER = () => `/register`;
